export default __webpack_public_path__ + "static/media/manau.8fcc549b.svg";